module.exports = __webpack_public_path__ + "img/24.fd94534f.jpg";